export default __webpack_public_path__ + "static/excited-corgi-739d09a8d16ccfed7b2c41c07e77595e.webp";